<div *ngIf="control" style="margin-bottom: 0.5rem">
  <label>{{ label }}</label>
  <br />
  <mat-radio-group [formControl]="control" [disabled]="isDisabled">
    <mat-radio-button *ngFor="let option of userDecisionOptions" [value]="option">
      {{ displayName(option) }}
    </mat-radio-button>
  </mat-radio-group>
  <mat-error *ngIf="control.touched && control.errors?.required">Bitte wählen Sie eine Option aus</mat-error>
</div>
